import { Injectable, Inject, InjectionToken, Optional } from '@angular/core';
import { AppConfig } from '../model/app-config';
import { environment } from '../../environments/environment';

export const APP_CONFIG: InjectionToken<AppConfig> = new InjectionToken<any>(
    'Application Configuration',
);

@Injectable()
export class AppConfigService {
    constructor(@Optional() @Inject(APP_CONFIG) appConfig: AppConfig) {
        if (appConfig) {
            environment.production = appConfig.production;
            environment.apiUri = appConfig.apiUri;
            environment.identityUri = appConfig.identityUri;
            environment.backofficeIdentityUri = appConfig.backofficeIdentityUri;
            environment.tokyoIdentityUri = appConfig.tokyoIdentityUri;
            environment.niigataIdentityUri = appConfig.niigataIdentityUri;
            environment.googleApiKey = appConfig.googleApiKey;
            environment.allowLinksToCms = appConfig.allowLinksToCms;
            environment.analyticsUri = appConfig.analyticsUri;
            environment.addressServiceUri = appConfig.addressServiceUri;
            environment.checkDuplicatedRegistrations =
                appConfig.checkDuplicatedRegistrations;
            environment.proposeAlternateCommunities =
                appConfig.proposeAlternateCommunities;
            environment.showLocationSelectors = appConfig.showLocationSelectors;
            environment.aiConnectionString = appConfig.aiConnectionString;
        }
    }
}
